/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const NestedDataSource = zod.strictObject({
    id: zod.number(),
    url: zod.string().nullable(),
});

export type NestedDataSource = zod.input<typeof NestedDataSource>;
export type NestedDataSourceOutput = zod.output<typeof NestedDataSource>;
